<template>
    <div class="collage-discount">
        <!--拼单折扣-->
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-input v-model="collageDiscountConfig.name" placeholder="拼单名称" :disabled="true"></el-input>
                    <el-input v-model="collageDiscountConfig.activeNo" placeholder="活动号" :disabled="true" v-show="false"></el-input>
                </el-col>
                <el-col :span="8">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    <el-button type="primary" @click="configCollageDiscount()" class="header-btn">新建折扣</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="collageConfigDiscountList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                  v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="id" label="折扣id" v-if="false" ></el-table-column>
            <el-table-column prop="num" label="人数"  >
            </el-table-column>
            <el-table-column  label="折扣" >
                <template slot-scope="scope">
                    <span>{{scope.row.discountRate}}折</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right"  >
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="deleteCollageDiscountConfig(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--<div class="productdetail-container" v-show="!listDiscountShow">-->
        <el-dialog title="折扣配置" :visible.sync="showDialog" width="50%" center class="main-title">
            <el-form :model="collageDiscountConfig" label-width="120px">
                <el-form-item label="拼单id" v-if="loading">
                    <el-input v-model="collageDiscountConfig.activeNo" placeholder="活动号"></el-input>
                </el-form-item>
                <el-form-item label="拼单人数" prop="num">
                    <el-input v-model="collageDiscountConfig.num" placeholder="拼单人数"></el-input>
                </el-form-item>
                <el-form-item label="拼单折扣"  prop="discountRate">
                    <el-input v-model="collageDiscountConfig.discountRate" placeholder="注意9折，请写9，98折写9.8"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="saveCollageDiscountConfig(collageDiscountConfig)" class="header-btn">保 存</el-button>
            </div>
        </el-dialog>
        <!--</div>-->
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        saveCollageDiscountConfig,
        getCollageDiscountConfigList,
        deleteCollageDiscountConfig
    } from '../../api/api';
    export default {
        data() {
            return {
                collageDiscountConfig:{
                    num:0,
                    discountRate:0.00,
                    activeNo:'',
                    name:''
                },
                listDiscountShow: true,//拼单折扣配置列表
                showDialog:false,
                collageConfigDiscountList:[],
                loading: true,
                rules: {
                    num: [
                        { required: true, message: '人数必填', trigger: 'blur' },
                        { type: 'number', message: '人数必须为数字值'}
                    ],
                    discountRate:[
                        { required: true, message: '折扣必填', trigger: 'blur' }
                    ]
                }
            }
        },
        created() {
            this.showDialog=false;
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            console.log(this.$route.query.activeNo);
            this.collageDiscountConfig.activeNo=this.$route.query.activeNo;
            this.collageDiscountConfig.name=this.$route.query.name;
            this.getCollageDiscountList();
            this.showDialog=false;
        },
        methods: {
            getCollageDiscountList(){
                this.loading = true;
                this.showDialog=false;
                getCollageDiscountConfigList({activeNo:this.collageDiscountConfig.activeNo}).then((res)=>{
                    if (res.data.status == 200) {
                        this.activeList = res.data.value.activeData;
                        this.loading = false;
                        this.collageConfigDiscountList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            configCollageDiscount(){
                this.listDiscountShow=false;
                this.showDialog=!this.listDiscountShow;
            },
            saveCollageDiscountConfig(data){
                for (var i = 0; i < this.collageConfigDiscountList.length; i++) {
                    if(this.collageDiscountConfig.num==this.collageConfigDiscountList[i].num){
                        this.$message({
                            message: '折扣对应的人数已存在',
                            type: 'error'
                        });
                        return;
                    }
                    if(this.collageDiscountConfig.discountRate==this.collageConfigDiscountList[i].discountRate){
                        this.$message({
                            message: '折扣已存在',
                            type: 'error'
                        });
                        return;
                    }
                }
                saveCollageDiscountConfig(data).then((res) => {
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getCollageDiscountList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            deleteCollageDiscountConfig(row){
                this.$confirm('删除折扣, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCollageDiscountConfig({id: row.id}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.getCollageDiscountList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            }
        }
    }
</script>

<style lang="scss">
    .collage-discount {
        .header-return {
            margin: 10px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/views/collage/collageDiscount.vue